import React from 'react';

// Styles & Assets
import styles from './CloseCaseInfo.module.css';

// Services
import { getDiagnosisCase, getFullName } from '../../../services/getPatientAtribute';

// Hooks
import { useTranslation } from 'react-i18next';

// Other
import moment from 'moment';

// Interfaces
import { Case, CloseReason } from '../../../interfaces/Patient';
import usePatientStore from '../../../stores/patient-store';
interface Props {
    caso: Case
    closureReason: CloseReason | null
}

const CloseCaseInfo: React.FC<Props> = ({ caso, closureReason }) => {

    const { t } = useTranslation();

    const patient = usePatientStore(state => state.patient);


    return (
        <div>
            <h1 className='dialogTitle' style={{ marginBottom: '2rem' }}>
                {caso.end_date === null ? t('sure_close_case') : t('sure_reopen_case')}
            </h1>
            <p className={styles.infoText}>
                <strong>{t('patient')}: </strong>{getFullName(patient)}
            </p>
            <p className={styles.infoText}>
                <strong>{t('case')}: </strong>{caso.hospital_case ?? caso.id}
            </p>
            <p className={styles.infoText}>
                <strong>{t('start_date')}: </strong>{moment(caso.start_date).format('DD/MM/YYYY')}
            </p>
            {caso.end_date &&
                <p className={styles.infoText}>
                    <strong>{t('end_date')}: </strong>{moment(caso.end_date).format('DD/MM/YYYY')}
                </p>
            }
            <p className={styles.infoText}>
                <strong>{t('diagnosis')}: </strong>{getDiagnosisCase(caso.patient_diagnosis ?? [])}
            </p>
            <p className={styles.infoText}>
                <strong>{t('closure')}: </strong>{closureReason?.name ?? '-'}
            </p>
        </div>
    );
};

export default CloseCaseInfo;